import React from "react";
import { useLocation } from "react-router-dom";
import AgentWantAdForm from "../components/AgentWantAdForm";
import { AGENT_WANTAD_KEY } from "@/constants/common";

const AgentCreateWantAd = () => {
  const location = useLocation();

  const initialData =
    location.state?.data ||
    JSON.parse(localStorage.getItem(AGENT_WANTAD_KEY));

  const isFromConfirmationPage = location.state?.isFromConfirmationPage === true;

  const isEdit = isFromConfirmationPage
    ? true
    : location.state?.data
      ? location.state.data.isEdit !== false
      : false;

  return <AgentWantAdForm initialData={initialData} isEdit={isEdit} />;
};

export default AgentCreateWantAd;
